/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import TemplateList from './TemplateList';

export default function Users(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <TemplateList />
      </MainLayout>
    </div>
  );
}
